import type {ImageLoaderProps} from 'next/image';

export default function contentfulLoader({src, width, quality}: ImageLoaderProps): string {
  if (!src.includes('images.ctfassets.net')) {
    return src;
  }
  const url = new URL(src);
  url.searchParams.set('w', String(width));
  url.searchParams.set('q', String(quality ?? 75));
  url.searchParams.set('fm', 'webp');
  return url.toString();
}